module.exports = __webpack_public_path__ + "static/terminal--deep_ocean.bac3a3623ecaca9861af615a7b670ba9.jpg";